import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import styled,{ withTheme } from 'styled-components';
import _ from 'lodash'
import QueueAnim from 'rc-queue-anim';

import {Upload,Progress,Alert,Modal,Typography,Tooltip} from 'antd';
import { EditOutlined,FileOutlined } from '@ant-design/icons';
import Language from './language';
import {to} from 'utils';

const Title = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;  
  line-height: 1.5714285714285714;
  flex: auto;
  transition: all .3s;
  margin-bottom: -10px;
`;

const Container=styled.div`
  .ant-alert-message{
    text-align: center;
  }

`;


export const UploadContainer = ({
  children,
  style,
  active=false,
  onFinish=()=>null,
  ...props  
  })=>{
    const [dragActive,setDragActive]   = React.useState(false);   
    if(!active)return <div style={style}>{children}</div>;  
    const _handleDrag = function(e) {    
      e.preventDefault();
      e.stopPropagation();
      
      if ((e.type === "dragenter" || e.type === "dragover")) {
        setDragActive(true);
      } else if (e.type === "dragleave") {
        setDragActive(false);
      }
    };
    const handleDrag =_.debounce( _handleDrag, 50);
  
    return dragActive?
      <UploadDragger  
        style={{height: "95vh"}} 
        onDragLeave={handleDrag} 
        onFinish={()=>setDragActive(false)||onFinish()}
        {...props} 
         /> :
      <div style={style} onDragEnter={handleDrag}>{children}</div>;        
};

export const UploadDragger = ({  
  onFinish=()=>null,
  // newItem:_newItem,
  upload=()=>null,
  multiple=false,
  onDragEnter=()=>null,
  onDragLeave=()=>null,
  style={}
})=>{
  
  const [waitingList,setWaitingFileList] = React.useState({});
  const [fileList,setFileList]           = React.useState({});
  const [completeList,setCompleteList]   = React.useState({});
  const [active,setActive]               = React.useState(false);
  
  const onChange=async({file,...other})=>{  
    const {uid}=file;
    setWaitingFileList(prevState=>({...prevState,[uid]:{name:file.name,originFileObj:file,uploading:false,error:undefined,percent:undefined}}));
    setActive(true);
    // setFileList(prevState=>({...prevState,[uid]:{name:file.name,originFileObj:file,uploading:false,error:undefined,percent:undefined}}));      
  };
  
  React.useEffect(() => {  
    waitingToUpload();
  },[waitingList,fileList]);
  
   React.useEffect(() => {  
    uploadFiles();
    if(Object.keys(fileList).length==0&&active){
      setActive(false);
      const responses=Object.keys(completeList).map(key=>completeList[key].response);      
      onFinish(responses);
    }
  },[fileList]);
  
  const waitingToUpload=()=>{
    
    if(Object.keys(waitingList).length >0 && Object.keys(fileList).length < 5){      
      const uid = Object.keys(waitingList)[0];
     
      // setFileList(prevState=>({...prevState,file}));
      
      setWaitingFileList(prevState=>{
         const {[uid]:file,...other}=prevState;
         setFileList({...fileList,[uid]:file});
        return other
        });
    }
  
  }
  
  const uploadFiles=async()=>{
    Object.keys(fileList).map(async uid=>{
      const file = fileList[uid];      
      const {originFileObj,uploading,remove}=file;
      if(!uploading){        
        setFileList(prevState=>{
          const {[uid]:file,...other}=prevState;      
          return{...other,[uid]:{...file,uploading:true, remove:false}}        
        });        
        const onUploadProgress = (e)=>_onUploadProgress(e,uid);        
        // const [error,response]=await to(_newItem?_newItem({id,file:originFileObj,onUploadProgress}):newItem({id,file:originFileObj,onUploadProgress}));            
        
        const [error,response]=await to(upload({file:originFileObj,onUploadProgress}));            
        setTimeout(()=> setFileList(prevState=>{
          const {[uid]:file,...other}=prevState;      
          return {...other,[uid]:{...file,uploading:true, remove:true,response,error}}    
        }),1000)             
      }
      if(remove){
        setFileList(prevState=>{
          const {[uid]:file,...other}=prevState; 
          setCompleteList(prevState=>{                 
            return{...prevState,[uid]:file}        
          })
          return{...other}        
        })
        
      }
      
    })
  }   
  
  const _onUploadProgress=(e,uid)=>{
    const { loaded, total } = e;    
    const percent = _.round(loaded/total*100.00, 0); 
    
    setFileList(prevState=>{
      const {[uid]:file,...other}=prevState;
      return {...other,[uid]:{...file,percent}};
    });    
  };
  
  
  const nwaiting = Object.keys(waitingList).length;
  
  return(
    <Container 
      style={{...style,width:"100%"}} 
      onDragEnter={onDragEnter} 
      onDragLeave={(event)=>!(event.currentTarget.contains(event.relatedTarget))&&onDragLeave(event)}
      >
      
      { Object.keys(fileList).length==0 &&!active?
        <Upload.Dragger 
            onChange={onChange}
            beforeUpload={file => false}
            maxCount={10}
            multiple
            fileList={[]}
            >
          <p className="ant-upload-drag-icon" style={{fontSize:30}}><FileOutlined /></p>
          <p className="ant-upload-text">Click or drag file to this area to upload</p>
          <p className="ant-upload-hint">Support for a single or bulk upload.</p>
          
          </Upload.Dragger>:
        <>
          <QueueAnim type={['right', 'left']} leaveReverse>
          {     
            Object.keys(fileList).sort().map(uid=>{               
              const {name,error,percent}=fileList[uid];
              return <div key={uid}>
                      <Title>{name}</Title>
                      { error?
                        <Tooltip title={error.message}><Progress percent={percent} status={"exception"}/></Tooltip>:
                        <Progress percent={percent}/>                                   
                      }
                  </div>
                }
              )
             
          }
          </QueueAnim>
          {nwaiting>0 && <Alert message={`In Queud (${nwaiting})`} type="info" />}               
        </>
      
    }
      
    </Container>
    );
};
 

export default ({
  
  visible=false,
  onCancel=()=>null,  
  ...other
  })=>{     
    return <Modal
      title={`Upload file`}
      onCancel={onCancel}
      open={visible}
      closable={true}
      width={400}
      footer={null}
    >
    <UploadDragger   
      {...other}
      />
    </Modal>;
   

}   